export default __webpack_public_path__ + "static/media/scanItem.b2881adb.svg";